<template>
    <div v-if="overlay">
        <v-overlay v-if="overlay && loading" :value="loading">
            <v-progress-circular indeterminate size="100" />
        </v-overlay>
        <slot />
    </div>
    <div v-else>
        <div v-if="loading" :class="[ loading ? 'd-flex' : 'd-none', 'justify-center pa-5 ma-5']">
            <v-progress-circular indeterminate size="100" />
        </div>

        <div v-show="!loading" :class="{'d-none': loading }">
            <slot v-show="!loading" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
                required: false
            },
            overlay: {
                type: Boolean,
                default: false,
                required: false
            }
        }
    }
</script>

<style>

</style>